
import {takeUntil} from 'rxjs/operators';
import { Global } from "../classes/Global";
import { StorageHelper } from "../helpers/StorageHelper";
import { ActivatedRoute } from "@angular/router";
import { Subject } from "rxjs";
import { Router } from "@angular/router";
import { Log } from "./Log";

import { InternationalizationHelper } from "./InternationalizationHelper";

export class UrlValidator {

  static validateUrl(route: ActivatedRoute, router, pageUrl: string, context: any){

    //it can happen that the language is not set yet
    const urlCountry = router.url.split('/')[1];
    let language = "en";
    //set the language based on the country in the url
    if(urlCountry && Global.countries[urlCountry]) {
      language = Global.countries[urlCountry].lang;
    }
    else {
      //there's no way to know which language we want, the url is invalid anyway
    }
    StorageHelper.getInstance().save(StorageHelper.keys.country, urlCountry);
    StorageHelper.getInstance().save(StorageHelper.keys.lang, language);

    let isSpecialUrl: boolean = false;

    if(router.url == ('/' + urlCountry + "/" + context.getString("onSaleUrl")) ||
      router.url == ('/' + urlCountry + "/charts") ||
      // router.url == ('/' + urlCountry + "/top-200") || // Temporarily disabled
      router.url == ('/' + urlCountry + "/coming-soon") ||
      router.url == ('/' + urlCountry + "/new-releases") ||
      router.url == ('/' + urlCountry + "/new-movies") ||
      router.url == ('/' + urlCountry + "/4k") ||
      router.url == ('/' + urlCountry + "/new-to-4k") ||
      router.url == ('/' + urlCountry + "/" + context.getString('itunesMovieDealsUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allMoviesUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('newOnPrimeVideoUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allSeasonsUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allAppsUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allMacAppsUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allMusicUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allAudiobooksUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('allBooksUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('movie4kUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('upgradedTo4kUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('movieBundlesUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('seasonsBundlesUrl')) ||
      router.url == ('/' + urlCountry + "/imdb-top-250") ||
      router.url == ('/' + urlCountry + "/" + context.getString('preorderUrl')) ||
      router.url == ('/' + urlCountry + "/" + context.getString('justReleasedUrl')) ||
      router.url == ('/' + urlCountry + "/greatest-hits")
    ){
      isSpecialUrl = true;
    }

    if(router.url.includes(context.getString("onSaleUrl"))) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.ON_SALE);
    }
    else if(
      router.url.includes(context.getString("actorsUrl")) ||
      router.url.includes(context.getString("writersUrl")) ||
      router.url.includes(context.getString("directorsUrl"))
    ) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.ON_SALE);
    }
    else if(router.url.includes("/charts")){
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.CHARTS);
    }
    // else if (router.url.includes("/top-200")) { // Temporarily disabled
    //   StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.TOP_200);
    // }
    else if (router.url.includes("/coming-soon")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.COMING_SOON);
    }
    else if (router.url.includes("/new-releases")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NEW_RELEASES);
    }
    else if (router.url.includes("/new-movies")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NEW_MOVIES);
    }
    else if (router.url.includes("/new-seasons")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NEW_SEASONS);
    }
    else if (router.url.includes("/4k-seasons")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.SEASONS_IN_4K);
    }
    else if (router.url.includes("/4k")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.MOVIES_IN_4K);
    }
    else if (router.url.includes("/new-to-4k")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NEW_TO_4K);
    }
    else if (router.url.includes("/classic-seasons")) {
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.CLASSIC_SEASONS);
    }
    else if(router.url.includes(context.getString('itunesMovieDealsUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
    }
    else if(router.url.includes(context.getString('allMoviesUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if (router.url.includes(context.getString('newOnPrimeVideoUrl'))) {
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NEW_ON_PRIME_VIDEO);
    }
    else if(router.url.includes(context.getString('allSeasonsUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.SEASONS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('allAppsUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.APPS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('allMacAppsUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.MACAPPS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('allMusicUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.ALBUMS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('allAudiobooksUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.AUDIOBOOKS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('allBooksUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.EBOOKS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.AZ);
    }
    else if(router.url.includes(context.getString('movie4kUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.MOVIES_4K);
    }
    else if(router.url.includes(context.getString('upgradedTo4kUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.UPGRADED_4K);
    }
    else if (router.url.includes(context.getString('movie3dUrl'))) {
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.MOVIES_3D);
    }
    else if(router.url.includes(context.getString('movieBundlesUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.BUNDLES);
    }
    else if(router.url.includes(context.getString('seasonsBundlesUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.SEASONS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.BUNDLES);
    }
    else if(router.url.includes("/imdb-top-250")){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.IMDBTOP250);
    }
    else if(router.url.includes(context.getString('preorderUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.PREORDER);
    }
    else if(router.url.includes(context.getString('justReleasedUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.BUYMOVIES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.JUST_RELEASED);
    }
    else if(router.url.includes(context.getString('newOniTunesUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.RECENTLYADDED);
    }
    else if(router.url.includes(context.getString('nowFreeUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.NOW_FREE);
    }
    else if (router.url.includes(context.getString('allAppsVisionProUrl'))) {
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.VISION_PRO_APPS);
    }
    else if(router.url.includes(context.getString('newOniTunesUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.RECENTLYADDED);
    }
    else if(router.url.includes("/greatest-hits")){
      StorageHelper.getInstance().save(StorageHelper.keys.store, Global.ITUNES);
      StorageHelper.getInstance().save(StorageHelper.keys.mediaType, Global.ALBUMS);
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.GREATESTHITS);
    }
    else if(router.url.includes(context.getString('blackFridayDealsUrl'))){
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.BLACK_FRIDAY);
    }

    switch(pageUrl) {
      case Global.MY_PURCHASES:
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.ON_SALE);
      break;
      case Global.SPECIAL_LISTS:
      StorageHelper.getInstance().save(StorageHelper.keys.listType, Global.ON_SALE);
      break;
    }

    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {

        let previousOrDefaultMediaType = Global.getMediaType();

        let store = params['store'] || Global.getStore();
        let country = params['country'] || Global.getCountry();
        let urlMediaType = params['mediaType'];

        if(store == "google-play") {
          store = Global.GOOGLEPLAY;
        }

        //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
        //So here I only take the second part when its the case
        if (country && country.length > 2){
          const parts = country.split('_');
          if (parts && parts.length >= 2) {
            country = parts[1];
          }
        }

        let mediaType = Global.getCorrespondingMediaType(urlMediaType) || Global.BUYMOVIES;
        if (mediaType === Global.MOVIES) { mediaType = Global.BUYMOVIES; }
        if (mediaType === Global.MUSIC) {
          if(previousOrDefaultMediaType !== Global.SINGLES) {
            mediaType = Global.ALBUMS;
          }
          else {
            mediaType = Global.SINGLES;
          }
        }

        if(Global.supportedStores.indexOf(store) >= 0 &&
          Global.supportedCountries[store][country] != null &&
          Global.supportedMediaTypes[store].indexOf(mediaType) >= 0)
        {
          //Save the new store, country and mediaType in the storage
          StorageHelper.getInstance().save(StorageHelper.keys.store, store);
          StorageHelper.getInstance().save(StorageHelper.keys.country, country);
          StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);

          //if it's a special url, redirect to full url automatically
          if(isSpecialUrl == true) {
            let targetUrl: string;
            if(pageUrl == "categories") {
              targetUrl = Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + InternationalizationHelper.getString("categoriesUrl") + "/" + Global.getListType();
            }
            else if(pageUrl == "on-sale") {
              targetUrl = Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + InternationalizationHelper.getString("onSaleUrl");
            }
            else {
              targetUrl = Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + pageUrl;
            }
            // Only navigate if URL actually changed to prevent excessive replaceState calls
            const currentUrl = router.url;
            const fullTargetUrl = "/" + targetUrl;
            if (currentUrl !== fullTargetUrl) {
              router.navigate([targetUrl], { replaceUrl: true });
            }
          }

        }
        else if(Global.supportedStores.indexOf(store) >= 0 && Global.supportedCountries[store][country] == null && Global.supportedCountries[Global.DEFAULT_STORE][country] != null) {
          //store is good, country is good, but country does not support the store
          //set store to default
          //Save the new store, country and mediaType in the storage
          StorageHelper.getInstance().save(StorageHelper.keys.store, Global.DEFAULT_STORE);
          StorageHelper.getInstance().save(StorageHelper.keys.country, country);
          StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
          const targetUrl = Global.getCountry() + "/" + Global.getStoreUrl() + "/" + Global.getMediaTypeForUrl() + "/" + InternationalizationHelper.getString("onSaleUrl");
          const fullTargetUrl = "/" + targetUrl;
          // Only navigate if URL actually changed to prevent excessive replaceState calls
          if (router.url !== fullTargetUrl) {
            router.navigate([targetUrl], { replaceUrl: true });
          }
        }
        else {
          router.navigate(["/" + Global.getCountry() + "/404"]);
        }

        //notifies that params have been received and route.params can be unsubscribed
        ngUnsubscribe.next();
        ngUnsubscribe.complete();

      }

    );

  }

  static validateDetailViewUrl(route: ActivatedRoute, router){

    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {
      let store = params['store'];
      let country = params['country'];
      let mediaType = params['mediaType'];

      if(store == "google-play") {
        store = Global.GOOGLEPLAY;
      }

      //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
      //So here I only take the second part when its the case
      if (country && country.length > 2){
        const parts = country.split('_');
        if (parts && parts.length >= 2) {
          country = parts[1];
        }
      }

      mediaType = Global.getCorrespondingMediaType(mediaType) || Global.getMediaType();

      if (Global.supportedStores.indexOf(store) != -1 &&
        Global.supportedCountries[store][country] != null &&
      Global.supportedDetailViewMediaTypes.indexOf(mediaType) != -1) {
        StorageHelper.getInstance().save(StorageHelper.keys.store, store);
        StorageHelper.getInstance().save(StorageHelper.keys.country, country);
        //In the api, detailView works with the media "movies",
        //But everywhere else it's "buymovies"
        // we only want to have "buymovies" or "rentalmovies" here.
        //So we put "buymovies" when it's "movies"
        if (mediaType === "movies"){
          const detailViewMediaType = StorageHelper.getInstance().get(StorageHelper.keys.detailViewMediaType);
          if (detailViewMediaType === Global.RENTALMOVIES) {
            mediaType = Global.RENTALMOVIES;
          }
          else {
            mediaType = Global.BUYMOVIES;
          }
        }
        StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
      }
      else {
        router.navigate(["/" + country + "/404"]);
      }

      //notifies that params have been received and route.params can be unsubscribed
      ngUnsubscribe.next();
      ngUnsubscribe.complete();

    });
  }

  static validateWishlistUrl(route: ActivatedRoute, router: Router) {
    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {
      let store = params['store'] || Global.getStore();
      let country = params['country'] || Global.getCountry();
      let mediaType = params['mediaType'] || Global.getMediaTypeForWishlistRequest();

      if(store == "google-play") {
        store = Global.GOOGLEPLAY;
      }

      //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
      //So here I only take the second part when its the case
      if (country && country.length > 2){
        const parts = country.split('_');
        if (parts && parts.length >= 2) {
          country = parts[1];
        }
      }

      mediaType = Global.getCorrespondingMediaType(mediaType) || Global.getMediaType();

      if (Global.supportedStores.indexOf(store) != -1 &&
        Global.supportedCountries[store][country] != null &&
      Global.supportedWishlistMediaTypes.indexOf(mediaType) != -1) {

        StorageHelper.getInstance().save(StorageHelper.keys.store, store);
        StorageHelper.getInstance().save(StorageHelper.keys.country, country);
        //In the api, wishlist works with the media "movies",
        //But everywhere else it's "buymovies"
        // we only want to have "buymovies" or "rentalmovies" here.
        //So we put "buymovies" when it's "movies"
        if (mediaType == "movies"){
          mediaType = "buymovies";
        }
        if (mediaType == "tv") {
          mediaType = "seasons";
        }
        if (mediaType == "music") {
          mediaType = "albums";
        }
        StorageHelper.getInstance().save(StorageHelper.keys.mediaType, mediaType);
      }
      else {
        router.navigate(["/" + country + "/404"]);
        Log.getInstance().d(router.url);
      }

      //notifies that params have been received and route.params can be unsubscribed
      ngUnsubscribe.next();
      ngUnsubscribe.complete();

    });
  }

  static validateCardDealDetailUrl(route: ActivatedRoute, router: Router) {
    //Notifier
    const ngUnsubscribe: Subject<any> = new Subject();

    route.params.pipe(takeUntil(ngUnsubscribe)) //take values until a notifier emits a value
    .subscribe(params => {
      let store = params['store'] || Global.getStore();
      let country = params['country'] || Global.getCountry();

      if(store == "google-play") {
        store = Global.GOOGLEPLAY;
      }

      //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
      //So here I only take the second part when its the case
      if (country && country.length > 2){
        const parts = country.split('_');
        if (parts && parts.length >= 2) {
          country = parts[1];
        }
      }

      if (Global.supportedStores.indexOf(store) != -1 &&
        Global.supportedCountries[store][country] != null) {

        StorageHelper.getInstance().save(StorageHelper.keys.store, store);
        StorageHelper.getInstance().save(StorageHelper.keys.country, country);

      }
      else {
        router.navigate(["/" + country +"/404"]);
        Log.getInstance().d(router.url);
      }

      //notifies that params have been received and route.params can be unsubscribed
      ngUnsubscribe.next();
      ngUnsubscribe.complete();

    });
  }

}
